import { DEPLOY_URL } from "../services/api";

/**
 * Link de pagamento de uma venda digitada: PIX ou cartão, o mesmo critério que o
 * apim2-service usa ao montar o e-mail (`/api/envio-email/digitada`).
 *
 * Centralizado aqui porque já existiam três lugares escolhendo a rota por conta própria —
 * e o do WhatsApp mandava /payment para venda PIX, o que abria a tela errada.
 *
 * Pix Direto (/direto) ficou de fora: foi descontinuado e está desabilitado.
 */
export function linkDePagamento(venda: { token: string; permitirPix?: boolean }) {
  return venda.permitirPix
    ? `${DEPLOY_URL}/pix?token=${venda.token}`
    : `${DEPLOY_URL}/payment?token=${venda.token}`;
}

/**
 * Link público de um boleto — a mesma página que o pagador abre.
 *
 * A URL estava escrita à mão em quatro lugares diferentes (modal de revisão,
 * modal de detalhe, iframe da visualização e o texto do WhatsApp). Centralizar
 * evita que um deles fique para trás no dia em que o domínio mudar.
 */
export function linkDoBoleto(id: string) {
  return `${DEPLOY_URL}/bolepix/view/${id}`;
}

/** Máscara de telefone: (00) 00000-0000, só dígitos. */
export function formatarTelefone(valor: string) {
  const d = valor.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export function telefoneValido(valor: string) {
  const d = valor.replace(/\D/g, "");
  return d.length === 10 || d.length === 11;
}

/**
 * Abre a conversa no WhatsApp com a mensagem pronta. Quem envia é o próprio WhatsApp
 * (Web ou app) — nada sai daqui, e o número não é gravado em lugar nenhum.
 */
export function abrirWhatsApp(telefone: string, link: string) {
  const digitos = telefone.replace(/\D/g, "");
  const texto = `Olá! Segue o link para o pagamento da sua compra: ${link}`;

  window.open(
    `https://wa.me/55${digitos}?text=${encodeURIComponent(texto)}`,
    "_blank",
    "noopener,noreferrer"
  );
}
